import { cn } from "@/lib/utils";

interface SignalIconProps {
  className?: string;
}

export function SignalIcon({ className }: SignalIconProps) {
  return (
    <span
      className={cn(
        "relative inline-block shrink-0 overflow-hidden",
        className
      )}
    >
      <img
        src="/Signal.png"
        alt=""
        aria-hidden="true"
        draggable={false}
        className="absolute inset-0 h-full w-full object-cover scale-125"
      />
    </span>
  );
}
